import { motion } from "framer-motion";

const projects = [
  {
    title: "E-Commerce Website",
    client: "Fashion Store",
    progress: 80,
    status: "In Progress",
  },
  {
    title: "Mobile Banking App",
    client: "Finance Company",
    progress: 60,
    status: "UI Development",
  },
  {
    title: "CRM Dashboard",
    client: "Software Company",
    progress: 95,
    status: "Testing",
  },
];

const ExistingProjectsUpdates = () => {
  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-br from-slate-950 via-violet-950 to-slate-900 px-6 py-28 text-white">

      {/* Background Effects */}
      <div className="absolute left-10 top-20 h-72 w-72 rounded-full bg-violet-500/20 blur-3xl"></div>

      <div className="absolute bottom-10 right-10 h-96 w-96 rounded-full bg-fuchsia-500/20 blur-3xl"></div>

      <div className="mx-auto max-w-7xl">

        {/* HERO */}
        <div className="text-center">

          <motion.h1
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-5xl font-black leading-tight md:text-7xl"
          >
            Existing Project
            <span className="bg-gradient-to-r from-violet-400 to-fuchsia-400 bg-clip-text text-transparent">
              {" "}Updates
            </span>
          </motion.h1>

          <p className="mx-auto mt-8 max-w-3xl text-lg leading-8 text-slate-300">
            Track your project progress, development stages,
            updates, and delivery timelines in real-time.
          </p>

        </div>

        {/* PROJECT CARDS */}
        <div className="mt-24 space-y-10">

          {projects.map((project, index) => (
            <motion.div
              key={index}
              whileHover={{
                scale: 1.02,
              }}
              className="rounded-[35px] border border-violet-500/20 bg-white/10 p-10 backdrop-blur-xl"
            >

              <div className="flex flex-col gap-6 md:flex-row md:items-center md:justify-between">

                <div>
                  <h2 className="text-3xl font-black">
                    {project.title}
                  </h2>

                  <p className="mt-3 text-lg text-slate-300">
                    Client: {project.client}
                  </p>
                </div>

                <div className="rounded-2xl bg-gradient-to-r from-violet-600 to-fuchsia-600 px-6 py-3 text-center font-bold">
                  {project.status}
                </div>

              </div>

              {/* Progress */}
              <div className="mt-10">

                <div className="mb-3 flex items-center justify-between">
                  <p className="font-semibold text-slate-300">
                    Project Progress
                  </p>

                  <p className="font-bold">
                    {project.progress}%
                  </p>
                </div>

                <div className="h-4 rounded-full bg-white/10">

                  <motion.div
                    initial={{ width: 0 }}
                    whileInView={{ width: `${project.progress}%` }}
                    transition={{ duration: 1 }}
                    className="h-full rounded-full bg-gradient-to-r from-violet-500 to-fuchsia-500"
                  ></motion.div>

                </div>

              </div>

            </motion.div>
          ))}

        </div>

        {/* CTA */}
        <div className="mt-32 rounded-[40px] border border-white/10 bg-white/10 p-16 text-center backdrop-blur-xl">

          <h2 className="text-4xl font-black md:text-6xl">
            Need Project Support?
          </h2>

          <p className="mx-auto mt-8 max-w-3xl text-lg leading-8 text-slate-300">
            Contact our support team for project updates,
            deployment assistance, or feature enhancements.
          </p>

          <button className="mt-10 rounded-2xl bg-gradient-to-r from-violet-600 to-fuchsia-600 px-10 py-5 text-lg font-bold transition-all duration-300 hover:scale-105">
            Contact Support
          </button>

        </div>

      </div>
    </div>
  );
};

export default ExistingProjectsUpdates;